import { ReactNode } from 'react'

import { Box } from '@domain-group/suit-theme'

interface OverlayProps {
  children?: ReactNode,
}

const Overlay = (props: OverlayProps) => {
  const { children } = props

  // Remember to make parent position="relative"
  return (
    <Box
      alignItems="center"
      backgroundColor="darkGrey"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      opacity={0.7}
      position="absolute"
      top={0}
      bottom={0}
      left={0}
      right={0}
    >
      {children}
    </Box>
  )
}

export default Overlay
